import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function ObilaznicaIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="ObilaznicaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <polygon fill="#FF0000" points="45.116,31.281 30.745,48.623 30.745,31.281 24.321,31.281 24.321,68.719 30.745,68.719 
        30.745,57.192 34.934,52.748 46.055,68.719 54.003,68.719 39.329,47.913 48.541,36.93 64.098,36.93 64.098,68.719 70.471,68.719 
        70.471,36.93 81.998,36.93 81.998,31.281 "/>
    </svg>
  </SvgIcon>
}

export default ObilaznicaIcon;
